import { thunk } from 'redux-thunk';
import multi from 'redux-multi';
import reduxCatch from 'redux-catch';
import timerMiddleware from './timerMiddleware';
import metricsMiddleware from '../metrics/metricsMiddleware';
import { trackException } from 'src/appInsights';

const errorHandler = (error, getState, lastAction, dispatch) => {
  console.error(error);
  trackException(error, {
    context: 'reduxMiddleware',
    lastAction: lastAction ? lastAction.type : 'unknown',
  });
};

const errorTrackingMiddleware = () => next => action => {
  try {
    const result = next(action);

    if (result && typeof result.catch === 'function') {
      return result.catch(error => {
        errorHandler(error, null, action);
        throw error;
      });
    }

    return result;
  } catch (error) {
    errorHandler(error, null, action);
    throw error;
  }
};

const rootMiddleware = addMiddleware => [errorTrackingMiddleware, thunk, multi, timerMiddleware, metricsMiddleware, reduxCatch(errorHandler), ...addMiddleware];

export default rootMiddleware;
